import { Component, ViewChild, DoCheck, OnInit, ViewEncapsulation } from '@angular/core';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { SelectableItem } from '../../models/common/selectableItem';
import { BlockUI } from 'ng-block-ui';
import { DateRangeModel } from '../../models/common/date.range';
import { TenderType } from '../../models/tenders/tender.enums';
import {TenderService} from '../../services/tender.service';
import {BookmarkedTenderSearchRequest} from '../../models/tenders/tender.models';
import {IPage} from '../../models/common/paging';
import {BookmarkedTenderSummaryDto} from '../../models/tenders/tender.models';
import { NoticeStatus, NoticeEnumsToSelectList} from '../../models/notices/notice.enums';
import { TenderTeamMemberSummaryDto } from '../../models/tender.team.members/tender.team.member.models';
import { TenderTeamMemberService } from '../../services/tender.team.member.service';
import { LoggedInUser, LoggedInUserService } from '../../auth/logged.in.user';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';
import { SortOption } from '../../models/tenders/sort.option';

@Component({
    selector: 'tenders/assigned',
    template: require('./assigned.component.html'),
    styles: [require('./assigned.component.css')],
    encapsulation: ViewEncapsulation.None
})
export class TendersAssignedComponent implements OnInit, DoCheck {
    request: BookmarkedTenderSearchRequest;
    private previousRequest: BookmarkedTenderSearchRequest;
    loading: boolean = false;

    deadlineDate: DateRangeModel;
    statuses: Array<SelectableItem<NoticeStatus>>;
    teamMembers: Array<TenderTeamMemberSummaryDto>;

    options: Array<SelectableItem<number>>;
    sortOptions = <SortOption[]>[];
    selectedSortOption: SortOption;
    sortOptionId: number;

    results: IPage<BookmarkedTenderSummaryDto>;
    resultOptions;

    @BlockUI('tender-results-block') private resultsBlock;
    @ViewChild('deleteModal', { static: false }) private deleteModal: any;
    @ViewChild('resultsPage', { static: false }) private resultsView;

    subscribed: boolean;
    dialogName: string;
    dialogHeader: string;
    dialogBody: string;

    private readonly user: LoggedInUser;

    constructor(private readonly tenderService: TenderService, private readonly teamMemberService: TenderTeamMemberService, private readonly helpers: Helpers,
        configuration: Configuration, private readonly loggedInUserService: LoggedInUserService,
        private readonly cmsDialogService: CmsDialogService) {
        this.request = new BookmarkedTenderSearchRequest(configuration);
        this.previousRequest = this.helpers.clone(this.request);

        this.deadlineDate = new DateRangeModel();

        this.user = loggedInUserService.getCurrentUser();        

        if (this.user.role === 'Supplier') {
            //this.request.teamMember = this.user.supplierId;
            this.resultOptions = {
                availableButtons: ['print', 'assign', 'sendToBidManagement']
            };
        }
        else {
            //this.request.teamMember = this.user.userId;
            this.resultOptions = {
                availableButtons: ['print']
            };
        }

        this.statuses = NoticeEnumsToSelectList.getStatuses();
        this.teamMembers = [];

        this.subscribed = !this.user.canAdHoc('notSubscribed');

        this.sortOptionId = 1;
        this.selectedSortOption = {
            id: 1,
            sortProperty: 'DeadlineDate',
            descending: false
        };
        this.sortOptions = [
            this.selectedSortOption,
            { id: 2, sortProperty: 'DeadlineDate', descending: true },
            { id: 3, sortProperty: 'Type', descending: false },
            { id: 4, sortProperty: 'Title', descending: false }
        ];
        this.options = [
            { text: 'Nearest Deadline Date', value: 1 },
            { text: 'Furthest Deadline Date', value: 2 },
            { text: 'Type', value: 3 },
            { text: 'Title', value: 4 }
        ];

        this.request.sortProperty = this.selectedSortOption.sortProperty;
        this.request.descending = this.selectedSortOption.descending;
    }

    ngOnInit() {
        document.body.classList.add('assigned-tenders-fit');

        this.loadTeamMembers();

        if (this.subscribed) {
            this.dialogName = 'Assigned Tenders Info - Subscribed';
        }
        else {
            this.dialogName = 'Assigned Tender Info - Not Subscribed';
        }

        this.cmsDialogService.getByDescription(this.dialogName).subscribe((result: CmsDialogDto) => {
            this.dialogHeader = result.header;
            this.dialogBody = result.body;
        });

        this.search();
    }

    ngOnDestroy() {
        document.body.classList.remove('assigned-tenders-fit');
        $('#assigned-tenders-info-modal').modal('hide');
    }

    private loadTeamMembers() {

        this.teamMemberService.getAll().subscribe((response: Array<TenderTeamMemberSummaryDto>) => {
            this.teamMembers = response;

            var yourself = new TenderTeamMemberSummaryDto();
            yourself.id = this.user.userId;
            yourself.name = "Yourself";
            this.teamMembers.splice(0, 0, yourself)
        });
    }

    ngDoCheck() {
        if (!this.request.equals(this.previousRequest)) {
            this.search();
        }
    }

    changeTypeFilter(type: string) {
        switch (type) {
        case 'high':
        {
            this.addOrRemoveTypeFromFilter(TenderType.High);
            this.addOrRemoveTypeFromFilter(TenderType.PrivateB2B);
            break;
        }
        case 'low':
        {
            this.addOrRemoveTypeFromFilter(TenderType.Low);
            break;
        }
        case 'pinHigh':
        {
            this.addOrRemoveTypeFromFilter(TenderType.PinHigh);
            break;
        }
        case 'pinLow':
        {
            this.addOrRemoveTypeFromFilter(TenderType.PinLow);
            break;
        }
        case 'private':
        {            
            this.addOrRemoveTypeFromFilter(TenderType.PrivateProject);
            break;
        }
        default:
            break;
        }

        this.search();
    }

    addOrRemoveTypeFromFilter(type: TenderType) {
        var idx = this.request.types.indexOf(type);

        if (idx > -1) {
            this.request.types.splice(idx, 1);
        } else {
            this.request.types.push(type);
        }
    }

    sortOptionChanged() {
        var id = +this.sortOptionId;
        this.selectedSortOption = this.sortOptions.find((option: SortOption) => {
            return option.id === id;
        });

        this.request.sortProperty = this.selectedSortOption.sortProperty;
        this.request.descending = this.selectedSortOption.descending;

        this.search();
    }

    search() {
        this.loading = true;
        this.resultsBlock.start();

        var deadlineDateDto = this.deadlineDate.convertDatesToDto();

        this.request.deadlineDateFrom = deadlineDateDto.startDate;
        this.request.deadlineDateTo = deadlineDateDto.endDate;

        if (this.previousRequest.pageNumber === this.request.pageNumber) {
            //We changed something other than the page number, so reset the search to page 1
            this.request.pageNumber = 0;
        }

        this.previousRequest = this.helpers.clone(this.request);

        this.tenderService.getAssigned(this.request).subscribe((results: IPage<BookmarkedTenderSummaryDto>) => {
            this.results = results;

            if (this.resultsView) {
                this.resultsView.onSearchComplete();
            }

            this.resultsBlock.stop();
            this.loading = false;
        }, () => {
            this.resultsBlock.stop();
            this.loading = false;
        });
    }
    
    removeBookmark(tender: BookmarkedTenderSummaryDto) {
        this.deleteModal.showAndPopulate(tender, tender.title);
    }

    confirmRemove(tender: BookmarkedTenderSummaryDto) {
        this.deleteModal.clearAndHide();
        this.tenderService.removeBookmark(tender.bookmarkId).subscribe(() => {
            this.search();
        });
    }

    showInfoDialog() {
        $('#assigned-tenders-info-modal').modal();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/tenders/assigned.component.ts